/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import { Card } from "@lightspeed/flame/Card";
import { Input } from "@lightspeed/flame/Input";
import { Button } from "@lightspeed/flame/Button";
import styled from "@emotion/styled";
//import { useForm } from "react-hook-form";
//import { uiSelector } from "../../../redux/slices/uiSlice";
import { IconSync } from "@lightspeed/flame/Icon/Sync";
import { IconDownload } from "@lightspeed/flame/Icon/Download";
import { FaInfoCircle, FaSave } from "react-icons/fa";
//import { useDispatch } from "react-redux";
//import { saveAs } from 'file-saver';
import { useState, useEffect, useRef } from "react";
import { ClipLoader } from "react-spinners";

const DEFAULT_REPORT_NAME = "Default";
const normalizeReportName = (name) => String(name || "").trim().toLowerCase();
const isDeferredReportName = (name) => normalizeReportName(name).includes("deferred");
const isDeferredV2ReportName = (name) => /deferred\s*v2/.test(normalizeReportName(name));
const getExportTotalsStorageKey = (userId, companyId, reportName) =>
  `reports.exportTotals:${userId || "anonymous"}:${companyId || "all"}:${normalizeReportName(reportName || DEFAULT_REPORT_NAME)}`;

const readStoredExportTotals = (storageKey) => {
  try {
    return window.localStorage.getItem(storageKey) === "true";
  } catch (error) {
    return false;
  }
};

// yesterday date will be default
const getYesterdayDate = () => {
  const current = new Date();
  current.setDate(current.getDate() - 1); 
  return current.toISOString().split('T')[0]; // YYYY-MM-DD
};

const StyledCard = styled(Card)`
  width: 240px;
  min-width: 240px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 18px 14px;
  border-radius: 24px;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(244, 248, 252, 0.98) 100%);
  box-shadow:
    0 22px 54px rgba(15, 23, 42, 0.12),
    0 8px 18px rgba(15, 23, 42, 0.06);
  border: 1px solid rgba(133, 150, 179, 0.18);

  @media (max-width: 1100px) {
    width: 100%;
    min-width: 0;
  }
`;

const StyledGroup = styled.div`
  margin: 0 0 16px;
  min-width: 0;

  label {
    margin-left: 2px;
    margin-bottom: 6px;
    display: block;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #5b6b81;
  }

  input {
    width: 100%;
    box-sizing: border-box;
  }
`;

// reusable component taking prop to create start and end date later
const InputGroup = ({ name, label, defaultValue, onChange }) => {
  return (
    <StyledGroup>
      <label htmlFor={name}>{label}</label>
      <Input 
        id={name} 
        name={name} 
        type="date" 
        defaultValue={defaultValue}
        onChange={onChange} 
      />
    </StyledGroup>
  );
};

// Select list for reports list
const SelectGroup = styled.div`
  margin: 0 0 16px;
  min-width: 0;
  
  label {
    margin-left: 4px;
    margin-bottom: 4px;
    display: block;
  }

  .select-and-button {
    display: flex; /* dropdown and button next to another */
    align-items: center; 
    gap: 6px; 
    width: 100%;
    min-width: 0;
  }

  select {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    min-height: 46px;
    padding: 10px 14px;
    border-radius: 14px;
    border: 1px solid #cfd8e6;
    background: #fbfdff;
    color: #24364b;
    font-weight: 600;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
    transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
  }

  select:focus {
    outline: none;
    border-color: #3498ff;
    box-shadow: 0 0 0 4px rgba(52, 152, 255, 0.14);
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

const ReportOption = styled.label`
  display: flex !important;
  align-items: center;
  gap: 8px;
  margin: 10px 0 0 4px !important;
  color: #24364b !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  line-height: 1.35;
  text-transform: none !important;

  input {
    width: 16px;
    height: 16px;
    margin: 0;
  }
`;

const SmallButton = styled(Button)`
  flex: 0 0 42px;
  min-width: 42px;
  min-height: 46px;
  padding: 0 10px;
  font-size: 12px;  
  display: flex;
  align-items: center;
  gap: 4px;  
  justify-content: center;
  border-radius: 14px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
  box-shadow: 0 10px 20px rgba(217, 119, 6, 0.22);

  svg {
    font-size: 12px; 
  }
`;

const InlineInfoButton = styled.button`
  width: 34px;
  height: 34px;
  margin-left: 10px;
  border: 1px solid #bad4f8;
  border-radius: 50%;
  background: #eef6ff;
  color: #1457b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: -10px;
  cursor: pointer;

  svg {
    font-size: 20px;
  }

  &:hover {
    background: #e1efff;
    border-color: #8fbbf2;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(52, 152, 255, 0.18);
  }
`;

const PanelHeader = styled.div`
  margin-bottom: 18px;
`;

const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(34, 110, 255, 0.1);
  color: #1457b8;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.16em;
  text-transform: uppercase;
`;

const PanelTitle = styled.h3`
  margin: 14px 0 6px;
  font-size: 24px;
  line-height: 1.1;
  color: #162333;
`;

const PanelSubtitle = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #66788f;
  overflow-wrap: anywhere;
`;

const ButtonLabel = styled.span`
  flex: 1;
  text-align: left;
`;

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8); 
  z-index: 9999; 
`;

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
  padding: 26px;
  border-radius: 22px;
  width: 420px;
  border: 1px solid rgba(135, 149, 173, 0.16);
  text-align: center;
  box-shadow: 0 22px 50px rgba(0, 0, 0, 0.22);
`;

const InfoModalContent = styled(ModalContent)`
  width: min(640px, calc(100vw - 32px));
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  text-align: left;

  h3 {
    margin: 0 0 10px;
    color: #162333;
    font-size: 22px;
  }

  h4 {
    margin: 18px 0 8px;
    color: #24364b;
    font-size: 14px;
  }

  p {
    margin: 8px 0;
    color: #4b5f78;
    line-height: 1.55;
  }

  ul {
    margin: 8px 0 0 18px;
    padding: 0;
    color: #4b5f78;
    line-height: 1.55;
  }
`;

const RuleBox = styled.div`
  margin: 14px 0;
  padding: 14px;
  border: 1px solid #d7e4f5;
  border-radius: 12px;
  background: #f6f9fd;
`;

const InfoTableWrapper = styled.div`
  margin: 14px 0;
  overflow-x: auto;
  border: 1px solid #d7e4f5;
  border-radius: 12px;

  table {
    width: 100%;
    min-width: 620px;
    border-collapse: collapse;
    color: #4b5f78;
    font-size: 13px;
  }

  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid #e3ebf5;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #eef5fd;
    color: #24364b;
    font-weight: 800;
  }

  tr:last-child td {
    border-bottom: 0;
  }
`;

const CodeRule = styled.code`
  display: inline-block;
  margin-top: 4px;
  padding: 3px 7px;
  border-radius: 6px;
  background: #e8f0fb;
  color: #163a67;
  font-size: 12px;
`;

const SaveButton = styled.button`
  background: linear-gradient(135deg, #1faa59 0%, #168b47 100%);  
  color: white;
  padding: 12px 24px; 
  border: none; 
  border-radius: 12px; 
  margin-right: 10px; 
  box-shadow: 0 12px 24px rgba(31, 170, 89, 0.22); 
  cursor: pointer; 

  &:hover {
    background-color: #218838;  
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15); 
  }

  &:active {
    background-color: #1e7e34;  
    box-shadow: none; 
  }

  &:focus {
    outline: none; 
  }
`;

const CancelButton = styled.button`
  background: linear-gradient(135deg, #ef4444 0%, #c62828 100%);  
  color: white;
  padding: 12px 24px; 
  border: none; 
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(220, 53, 69, 0.18);
  cursor: pointer;

  &:hover {
    background-color: #c82333;  
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    background-color: #bd2130;  
    box-shadow: none;
  }

  &:focus {
    outline: none; 
  }
`;


const Modal = ({ show, handleClose, handleSave, reportName, newReportName, setNewReportName }) => {
  if (!show) return null; 

  return (
    <ModalBackground>
      <ModalContent>
        <h3>Confirm Save</h3>
        <p>Save report settings?</p>
        {/* Report name */}
        <div style={{ marginBottom: '15px', textAlign: 'left' }}>
           <label htmlFor="reportName" style={{ display: 'block', marginBottom: 6, fontSize: 12, fontWeight: 700, color: '#4b5563' }}>
             Current report
           </label>
           <Input
             id="reportName"
             name="reportName"
             value={reportName}
             readOnly
             aria-readonly="true"
             style={{ background: '#f3f4f6', cursor: 'not-allowed' }}
           />
         </div>
         <div style={{ marginBottom: '15px', textAlign: 'left' }}>
           <label htmlFor="newReportName" style={{ display: 'block', marginBottom: 6, fontSize: 12, fontWeight: 700, color: '#4b5563' }}>
             New report name
           </label>
           <Input
             id="newReportName"
             name="newReportName"
             value={newReportName}
             placeholder="Leave empty to update current report"
             onChange={(e) => setNewReportName(e.target.value)}
           />
         </div>
        <SaveButton onClick={handleSave}>Save</SaveButton>
        <CancelButton onClick={handleClose}>Cancel</CancelButton>
      </ModalContent>
    </ModalBackground>
  );
};

const DeferredReportInfoModal = ({ show, handleClose, reportName }) => {
  if (!show) return null;

  const isDeferredV2 = isDeferredV2ReportName(reportName);

  return (
    <ModalBackground onClick={handleClose}>
      <InfoModalContent onClick={(e) => e.stopPropagation()}>
        {isDeferredV2 ? (
          <>
            <h3>How the Deferred V2 Report Works</h3>
            <p>
              The Deferred V2 Report separates the date when a sale or payment was
              made from the date when the revenue should be recognized, based on the
              Tee Time date.
            </p>
            <RuleBox>
              <h4>Deferred Pre Paid</h4>
              <p>The sale or payment was made before the current reporting period, but the Tee Time falls within the current reporting period. The payment was received earlier, and the revenue is now being recognized.</p>
            </RuleBox>
            <RuleBox>
              <h4>Future Revenue</h4>
              <p>The Tee Time date is after the end of the reporting period. The customer has already paid, but the service will be provided in the future, so the amount is treated as deferred or future revenue.</p>
            </RuleBox>
            <RuleBox>
              <h4>Paid on Date</h4>
              <p>The Tee Time falls within the relevant reporting period. The revenue can therefore be recognized for that period.</p>
            </RuleBox>
            <RuleBox>
              <h4>Sale</h4>
              <p>There is no Tee Time associated with the transaction, so it is treated as a regular sale.</p>
            </RuleBox>
            <h4>Example: August 1–31</h4>
            <InfoTableWrapper>
              <table>
                <thead>
                  <tr><th>Sale Date</th><th>Tee Time</th><th>Classification</th><th>Explanation</th></tr>
                </thead>
                <tbody>
                  <tr><td>July 15</td><td>August 10</td><td>Deferred Pre Paid</td><td>Paid earlier, revenue recognized in August</td></tr>
                  <tr><td>August 5</td><td>September 20</td><td>Future Revenue</td><td>Paid in August, service will be provided in September</td></tr>
                  <tr><td>August 5</td><td>August 20</td><td>Paid on Date</td><td>Payment and service belong to the current period</td></tr>
                  <tr><td>August 5</td><td>None</td><td>Sale</td><td>Regular sale without a Tee Time</td></tr>
                </tbody>
              </table>
            </InfoTableWrapper>
            <p>
              If a golfer pays $100 on July 15 for a Tee Time on August 10, the $100
              is initially considered prepaid or deferred revenue. When the August
              report is generated, Deferred V2 finds this transaction even though
              the original sale happened in July, because its Tee Time falls in August.
              The revenue can then be recognized in August.
            </p>
            <p>
              Conversely, if a golfer pays $100 on August 10 for a Tee Time on
              September 5, the August report treats the payment as Future Revenue,
              because the service will not be provided until September.
            </p>
            <RuleBox>
              <p>
                In summary, Deferred V2 recognizes revenue based on when the service
                is scheduled to be provided (Tee Time), rather than relying only on
                when the sale or payment was originally made. It can therefore include
                transactions from previous periods when their Tee Time falls within
                the selected reporting period.
              </p>
            </RuleBox>
          </>
        ) : (
          <>
            <h3>Deferred Report logic</h3>
            <p>The Deferred Report is based on the sale created date. A sale is included when it was created within the selected date range. The report then checks the tee time date to decide whether the sale is realized or deferred.</p>
            <RuleBox><h4>Realized sale</h4><p>A sale is considered realized when:</p><CodeRule>tee time date is empty</CodeRule><p>or</p><CodeRule>tee time date &lt;= report end date</CodeRule></RuleBox>
            <RuleBox><h4>Deferred sale</h4><p>A sale is considered deferred when:</p><CodeRule>tee time date &gt; report end date</CodeRule></RuleBox>
            <h4>Date comparison</h4>
            <ul><li>If the sale does not have a tee time, it is treated as realized.</li><li>The comparison uses the date only, not the exact time.</li><li>The report end date is inclusive.</li></ul>
            <h4>Example</h4>
            <p>For report period May 1 - May 7, a sale created on May 2 is included. If the tee time is May 5, it is realized. If the tee time is May 10, it is deferred.</p>
          </>
        )}
        <div style={{ marginTop: 22, textAlign: "right" }}>
          <CancelButton onClick={handleClose}>Close</CancelButton>
        </div>
      </InfoModalContent>
    </ModalBackground>
  );
};

// chiled component DatePicker - added onReportChange prop to accept
const DatePicker = ({ updateAction, tableRef, userId, companyId, companyType, onReportChange, onSaveReport, onDateChange, analyticsAutoSaveTrigger, autoSyncOnLoad = false }) => {
  const yesterday = getYesterdayDate();
  const [fromDate, setFromDate] = useState(yesterday);  // default start date state
  const [toDate, setToDate] = useState(yesterday);      // default end date state

  useEffect(() => {
    if (onDateChange) {
      onDateChange(fromDate, toDate);
    }
  }, [fromDate, toDate]);
  const [loading, setLoading] = useState(false);        // loading state used for SYNC button
  const [reportList, setReportList] = useState([]);     // state for report list in dropdown
  const [selectedReport, setSelectedReport] = useState(DEFAULT_REPORT_NAME); // state for selected report
  const [showModal, setShowModal] = useState(false);
  const [showDeferredInfo, setShowDeferredInfo] = useState(false);
  const [reportName, setReportName] = useState(DEFAULT_REPORT_NAME);
  const [newReportName, setNewReportName] = useState("");
  const [reportChanged, setReportChanged] = useState(false); // track report change (from Select Report list) - to trigger data reload behind SYNC
  const [savedReportName, setSavedReportName] = useState(DEFAULT_REPORT_NAME); // persistent state for report name
  const [savedReportId, setSavedReportId] = useState("");     // persistent state for report ID
  const analyticsAutoSaveInProgress = useRef(false);
  const analyticsAutoSavePending = useRef(false);
  const [showDateAsMonthEnd, setShowDateAsMonthEnd] = useState(false);
  const [exportTotals, setExportTotals] = useState(false);
  const hasDefaultReport = reportList.some(
    report => normalizeReportName(report.report_name) === normalizeReportName(DEFAULT_REPORT_NAME)
  );

  const isNetSuiteReport = (selectedReport || reportName || "")
    .toLowerCase()
    .includes("netsuite");
  const isDeferredReport = isDeferredReportName(selectedReport || reportName);
  const isDeferredV2Report = isDeferredV2ReportName(selectedReport || reportName);
  const activeReportName = savedReportName || reportName || selectedReport || DEFAULT_REPORT_NAME;
  const exportTotalsStorageKey = getExportTotalsStorageKey(
    userId,
    companyId,
    activeReportName
  );

 
    // xoption based on company type
    const getXOption = () => {
      if (companyType === "RESTOK") {
        return "get_report_list_k";
      } else if (companyType === "RESTOL") {
        return "get_report_list_l";
      } else {
        return "get_report_list"; // Default case
      }
    };

  // fetch the list of reports just when component mounts
  useEffect(() => {
    let isActive = true;

    setReportList([]);
    setSelectedReport(DEFAULT_REPORT_NAME);
    setReportName(DEFAULT_REPORT_NAME);
    setReportChanged(false);
    setSavedReportName(DEFAULT_REPORT_NAME);
    setSavedReportId("");
    setShowDateAsMonthEnd(false);

    const fetchReports = async () => {
      try {
        const response = await fetch("https://reportapi.beesql.com/api/admin/report/settings", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            token_user_id: userId,
            company_id: companyId,
            report_name: "",
            xoption:  getXOption(),//"get_report_list",
          })
        });
        const data = await response.json();
        //console.log("report list:", data); 
        const sortedReports = Array.isArray(data)
          ? [...data].sort((a, b) =>
              (a?.report_name || "").localeCompare(b?.report_name || "")
            )
          : [];

        if (!isActive) return;

        setReportList(sortedReports); 

        const defaultReport = sortedReports.find(
          report => normalizeReportName(report.report_name) === normalizeReportName(DEFAULT_REPORT_NAME)
        );

        if (defaultReport) {
          const defaultReportName = defaultReport.report_name || DEFAULT_REPORT_NAME;
          const isDefaultNetSuiteReport = defaultReportName
            .toLowerCase()
            .includes("netsuite");

          setSelectedReport(defaultReportName);
          setReportName(defaultReportName);
          setShowDateAsMonthEnd(isDefaultNetSuiteReport);
          setSavedReportName(defaultReportName);
          setSavedReportId(defaultReport.id || defaultReport.report_id || "");

          onReportChange(
            (defaultReport.rows || "").split(',').map(r => r.trim()).filter(Boolean),
            defaultReport.id ?? defaultReport.report_id ?? "",
            defaultReportName,
            (defaultReport.sum_field || "").split(',').map(f => f.trim()).filter(Boolean),
            (defaultReport.cols_fields || "").split(',').map(c => c.trim()).filter(Boolean)
          );
        }

        // Sync only after the new company's saved layout has reached the parent.
        // An empty report list uses the built-in Default layout.
        if (autoSyncOnLoad) {
          setReportChanged(true);
        }
      } catch (error) {
        if (isActive) {
          console.error("Error fetching report list:", error);
        }
      }
    };

    fetchReports();

    return () => {
      isActive = false;
    };
  }, [userId, companyId]); // dependency array to run useEffect again if userId or companyId states change

  const handleReportChange = (e) => {
    const selectedReport = reportList.find(report => report.report_name === e.target.value);
    const nextReportName = selectedReport?.report_name || "";
    const isNextNetSuiteReport = nextReportName.toLowerCase().includes("netsuite");
  
    setSelectedReport(e.target.value);  // temp state for current report
    setReportName(nextReportName); // for modal
    setShowDateAsMonthEnd(isNextNetSuiteReport);
    
    // persist report details in state for SYNC
    setSavedReportName(nextReportName);
    setSavedReportId(selectedReport?.id || "");
  
    console.log("Updated saved report name after selection:", savedReportName);
    console.log("Updated saved report ID after selection:", savedReportId);
  
    // data reload with selected report details
    //onReportChange(selectedReport?.rows.split(',').map(row => row.trim()), selectedReport?.id, selectedReport?.report_name);
    onReportChange(
      (selectedReport?.rows || "").split(',').map(r => r.trim()).filter(Boolean),
      selectedReport?.id ?? selectedReport?.report_id ?? "",
      nextReportName,
      (selectedReport?.sum_field || "").split(',').map(f => f.trim()).filter(Boolean),
      (selectedReport?.cols_fields || "").split(',').map(c => c.trim()).filter(Boolean)
    );

    setReportChanged(true);  // flag to trigger sync
  };
  
  
  /*const onSubmit = (e) => {
    dispatch(
      updateAction({
        ...e,
      })
    );*/

  useEffect(() => {
    setExportTotals(readStoredExportTotals(exportTotalsStorageKey));
  }, [exportTotalsStorageKey]);

  useEffect(() => {
     if (reportChanged) {
      handleSync(); // trigger original sync when report columns are changed by Report List selection
      setReportChanged(false); // reset flag after sync
     }
  }, [reportChanged]); // watch when reportChanged is set to true

  const handleSync = async () => {
    console.log("Sync triggered");
  
    // Use the persistent state variables
    const reportNameToSend = savedReportName || reportName || ""; //report_name is always passed
    const reportIdToSend = savedReportId || ""; // ID is sent if available
  
    console.log("Syncing with payload: ", {
      fromDate,
      toDate,
      reportName: reportNameToSend, 
      reportId: reportIdToSend,    
      showDateAsMonthEnd,
    });
  
    if (!reportNameToSend) {
      console.error("No report_name found! Something went wrong with state.");
    }
  
    setLoading(true); // Start loading spinner
  
    try {
      await updateAction(fromDate, toDate, reportNameToSend, reportIdToSend, showDateAsMonthEnd); 
    } finally {
      setLoading(false); // Stop spinner
    }
  };
  
    
  // Export to Excel function
  const exportToExcel = () => {
    if (tableRef && tableRef.current) {
      // Table.js exposed export function
      tableRef.current.export({ includeTotals: exportTotals }); 
    }
  };

  const exportToCSV = () => {
    if (tableRef && tableRef.current) {
      // Table.js exposed CSV export function
      tableRef.current.exportToCSV(savedReportName || reportName || selectedReport, {
        includeTotals: exportTotals,
      });  
    }
  };

  const handleExportTotalsChange = (e) => {
    const checked = e.target.checked;
    setExportTotals(checked);

    try {
      window.localStorage.setItem(exportTotalsStorageKey, checked ? "true" : "false");
    } catch (error) {
      console.warn("Could not store Export Totals option:", error);
    }
  };

  // show modal when click save icon
  const handleSaveClick = () => {
    //if no report is selected, first set the name to empty for new report
    if (!selectedReport) {
      setReportName("");  
    }

    setNewReportName("");
    setShowModal(true);  
  };

  const handleCloseModal = () => {
    setNewReportName("");
    setShowModal(false);
  };

  // func for saving report after confirmation
  const handleConfirmSave = async () => {
    const trimmedNewReportName = newReportName.trim();
    const reportNameToSave = [reportName.trim(), trimmedNewReportName]
      .filter(Boolean)
      .join(" ");
    const saveAsNewReport = Boolean(trimmedNewReportName);

    await updateReportWithCurrentColumns(reportNameToSave, saveAsNewReport);
    refetchReportsAndUpdateColumns(reportNameToSave);
  
    setTimeout(() => {
      if (onSaveReport) {
        console.log("Calling onSaveReport with:", savedReportId, reportNameToSave); 
        onSaveReport(savedReportId, reportNameToSave);
      }
      setNewReportName("");
      setShowModal(false); // close modal after saving
    }, 900);
  };
  

  const updateReportWithCurrentColumns = async (updatedReportName, saveAsNewReport = false) => {
    if (tableRef && tableRef.current) {
      const { rows, cols, vals } = tableRef.current.getColumns(); // current columns!
  
      const reportDetails = {
        report_name: updatedReportName, // updated report name passed as argument
        rows: rows.join(','), // rows array to string
        cols_fields: cols.join(','), // cols array to string
        sum_field: vals.join(','), // vals array to string
        token_user_id: userId,
        company_id: companyId,
        xoption: getXOption(), // save settings!!
      };
  
      if (!selectedReport || saveAsNewReport) {
        // new report: save the new report
        await saveReportSettings(reportDetails);
      } else {
        // existing report: update report
        const reportToUpdate = reportList.find(report => report.report_name === selectedReport);
        if (reportToUpdate) {
          const updatedReport = {
            ...reportToUpdate,
            rows: rows.join(','), // update with new rows
            cols_fields: cols.join(','), // udate with new cols
            sum_field: vals.join(','), // update with new vals
            report_name: updatedReportName, // use updated report name
          };
          await saveReportSettings(updatedReport); // save updated report!
        }
      }
    }
  };
  

  const refetchReportsAndUpdateColumns = async (reportName) => {
    try {
      const response = await fetch("https://reportapi.beesql.com/api/admin/report/settings", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token_user_id: userId, company_id: companyId, xoption: "get_report_list" })
      });
      const data = await response.json();
      setReportList(data);
  
      // update saved report details after refetching
      const updatedReport = data.find(report => report.report_name === reportName);
      if (updatedReport) {
        // upd state with saved report
        setSavedReportId(updatedReport.report_id || "");
        setSavedReportName(updatedReport.report_name || "");
        onReportChange(updatedReport.rows.split(',').map(row => row.trim()), updatedReport.id, updatedReport.report_name, updatedReport.sum_field.split(','), updatedReport.cols_fields.split(','));
      }
      return updatedReport;
    } catch (error) {
      console.error("Error re-fetching the report list:", error);
      return null;
    }
  };

  useEffect(() => {
    const activeName = savedReportName || reportName || selectedReport || "";

    if (
      !analyticsAutoSaveTrigger ||
      !normalizeReportName(activeName).includes("analytics")
    ) {
      return;
    }

    if (analyticsAutoSaveInProgress.current) {
      analyticsAutoSavePending.current = true;
      return;
    }

    const autoSaveAndRefresh = async () => {
      analyticsAutoSaveInProgress.current = true;
      setLoading(true);

      try {
        await updateReportWithCurrentColumns(activeName, false);
        const updatedReport = await refetchReportsAndUpdateColumns(activeName);
        const reportId = updatedReport?.id ?? updatedReport?.report_id ?? savedReportId ?? "";
        const refreshedRows = (updatedReport?.rows || "")
          .split(",")
          .map((field) => field.trim())
          .filter(Boolean);
        const refreshedCols = (updatedReport?.cols_fields || "")
          .split(",")
          .map((field) => field.trim())
          .filter(Boolean);

        if (onSaveReport) {
          onSaveReport(reportId, activeName);
        }

        await updateAction(
          fromDate,
          toDate,
          activeName,
          reportId,
          showDateAsMonthEnd,
          refreshedRows,
          refreshedCols
        );
      } finally {
        setLoading(false);
        analyticsAutoSaveInProgress.current = false;

        if (analyticsAutoSavePending.current) {
          analyticsAutoSavePending.current = false;
          setTimeout(autoSaveAndRefresh, 0);
        }
      }
    };

    autoSaveAndRefresh();
  }, [analyticsAutoSaveTrigger]);
  
  

const saveReportSettings = async (updatedReport) => {
  try {
    const response = await fetch("https://reportapi.beesql.com/api/admin/report/settings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...updatedReport,
        xoption: "save_settings"
      })
    });
    const data = await response.json();
    console.log("Report updated:", data);
  } catch (error) {
    console.error("Error saving report settings:", error);
  }
};

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <ClipLoader size={50} color="#36d7b7" />
        </LoadingOverlay>
      )}
    <StyledCard>
      <PanelHeader>
        <PanelSubtitle>
          Pick a saved layout, adjust the date range, then sync data and export the result.
          {isDeferredReport && (
            <InlineInfoButton
              type="button"
              onClick={() => setShowDeferredInfo(true)}
              title={isDeferredV2Report ? "Deferred V2 Report logic" : "Deferred Report logic"}
              aria-label={isDeferredV2Report ? "Deferred V2 Report logic" : "Deferred Report logic"}
            >
              <FaInfoCircle />
            </InlineInfoButton>
          )}
        </PanelSubtitle>
      </PanelHeader>
      <form onSubmit={(e) => e.preventDefault()}>
        <SelectGroup>
          {/*<label htmlFor="reportSelect">Select Report:</label>*/}
          <div className="select-and-button">
          <select
            id="reportSelect"
            value={selectedReport}
            onChange={handleReportChange}
          >
          <option value="" disabled>Select Report...</option>
          {!hasDefaultReport && (
            <option value={DEFAULT_REPORT_NAME}>{DEFAULT_REPORT_NAME}</option>
          )}
            {reportList.map((report) => (
              <option key={report.id} value={report.report_name}>
                {report.report_name}
              </option>
             ))}
          </select>
        <SmallButton type="button" onClick={handleSaveClick} title="Save current report settings">
          <FaSave /> 
        </SmallButton>
        </div>
        {isNetSuiteReport && (
          <ReportOption title="When enabled, Sync Report sends this option and displays Date as the final calendar day of that month.">
            <input
              type="checkbox"
              checked={showDateAsMonthEnd}
              onChange={(e) => setShowDateAsMonthEnd(e.target.checked)}
            />
            Group totals by date (End Date)
          </ReportOption>
        )}
        </SelectGroup>
        <InputGroup 
          name="start_date" 
          label="Start Date:" 
          defaultValue={fromDate} 
          onChange={(e) => setFromDate(e.target.value)}
        />
        <InputGroup 
          name="end_date" 
          label="End Date:" 
          defaultValue={toDate} 
          onChange={(e) => setToDate(e.target.value)}
        />
        <ButtonWrapper>
          <ReportOption title="When enabled, Excel and CSV exports include Totals columns and rows.">
            <input
              type="checkbox"
              checked={exportTotals}
              onChange={handleExportTotalsChange}
            />
            Export Totals
          </ReportOption>
       {/*  <Button type="submit"> */}
          <Button type="button" onClick={handleSync}>
            <ButtonLabel>Sync Report</ButtonLabel>
            <IconSync />
          </Button>
          <Button type="button" onClick={exportToExcel}>
            <ButtonLabel>Export Excel</ButtonLabel>
            <IconDownload />
          </Button>
          <Button type="button" onClick={exportToCSV}>
            <ButtonLabel>Export CSV</ButtonLabel>
            <IconDownload />
          </Button>
        </ButtonWrapper>
      </form>
    </StyledCard>
    {/* Modal */}
    <Modal
        show={showModal}
        handleClose={handleCloseModal}
        handleSave={handleConfirmSave}
        reportName={reportName} // pass report name to modal
        newReportName={newReportName}
        setNewReportName={setNewReportName}
      />
    <DeferredReportInfoModal
      show={showDeferredInfo}
      handleClose={() => setShowDeferredInfo(false)}
      reportName={selectedReport || reportName}
    />
    </>
  );
};

export default DatePicker;
